module.exports = __webpack_public_path__ + "static/sample_OCEAN_PC-90be16f0ef777767f06b08338390d787.png";